import styles from "css/buttons/NextAndBackButton.module.css";

type Props = {
  children: any;
};

export default function NextAndBackButton({ children }: Props): JSX.Element {
  return <div className={styles.container}>{children}</div>;
}
